<script setup lang="ts">
import ButtonDaisy from '@/components/common/buttons/ButtonDaisy.vue'

defineProps({
  text: String,
  icon: Object,
  tooltipPosition: {
    type: String,
    default: 'top',
  },
  variant: {
    type: String,
    default: 'default',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'sm',
  },
  sizeIcon: {
    type: String,
    default: '4',
  },
  rounded: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div :class="disabled ? '' : 'tooltip tooltip-' + tooltipPosition" :data-tip="text">
    <ButtonDaisy
      text=""
      :icon="icon"
      :variant="variant"
      :disabled="disabled"
      :size="size"
      :sizeIcon="sizeIcon"
      :type="'button'"
      :rounded="rounded"
    >
      <slot />
    </ButtonDaisy>
  </div>
</template>
